module.exports = __webpack_public_path__ + "static/media/eos.9f4ecc14.png";